/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert between different categories, like length to weight?`)
};

const es_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo convertir entre diferentes categorías, como longitud a peso?`)
};

const de_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich zwischen verschiedenen Kategorien umrechnen, zum Beispiel von Länge zu Gewicht?`)
};

const nl_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik tussen verschillende categorieën converteren, zoals lengte naar gewicht?`)
};

const fr_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je convertir entre différentes catégories, comme la longueur en poids ?`)
};

const it_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso convertire tra categorie diverse, come lunghezza in peso?`)
};

const pt_br2_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter entre diferentes categorias, como comprimento para peso?`)
};

const pt_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter entre categorias diferentes, como comprimento para peso?`)
};

const ja_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さから質量への変換など、異なるカテゴリ間で変換できますか?`)
};

const zh_uc_hub_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_faq4_q", locale)
	if (locale === "en") return en_uc_hub_faq4_q(inputs)
	if (locale === "es") return es_uc_hub_faq4_q(inputs)
	if (locale === "de") return de_uc_hub_faq4_q(inputs)
	if (locale === "nl") return nl_uc_hub_faq4_q(inputs)
	if (locale === "fr") return fr_uc_hub_faq4_q(inputs)
	if (locale === "it") return it_uc_hub_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_faq4_q(inputs)
	if (locale === "pt") return pt_uc_hub_faq4_q(inputs)
	if (locale === "ja") return ja_uc_hub_faq4_q(inputs)
	return zh_uc_hub_faq4_q(inputs)
};